"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when the entity is not found
 * @param {string} message the validation message
 */
class EntityNotFoundError extends client_library_1.ExtendableError {
    constructor(errorCode) {
        super(`Requested entity does not exist: ${errorCode}`);
    }
}
exports.default = EntityNotFoundError;
//# sourceMappingURL=EntityNotFoundError.js.map